import { useCallback, useRef } from 'react';

import { T } from '@app/components/translation';
import toast, { Button } from '@app/components/toasts';
import { UNASSIGNED_SIGNATURE_FIELDS_TOAST_ID } from './unassigned-fields-toast';

const UnassignedFieldsToastButton = () => {
  const currentFieldIndexRef = useRef(0);

  const findUnassignedSignatureFields = useCallback(() => {
    const signatureFields = document.querySelectorAll('svg[data-signature-field-assigned="false"]');

    if (signatureFields.length === 0) {
      return [];
    }

    return Array.from(signatureFields);
  }, []);

  const handleClick = () => {
    const fields = findUnassignedSignatureFields();

    toast.update({
      id: UNASSIGNED_SIGNATURE_FIELDS_TOAST_ID,
      title: (
        <T
          _str="Unassigned Signature fields"
          _comment="Info text explaining that the document has unassigned fields."
        />
      ),
      description: (
        <T
          _str="You have {count} unassigned Signature fields."
          _comment="Notification message for missing required fields"
          count={fields.length}
        />
      ),
    });

    if (currentFieldIndexRef.current >= fields.length) {
      currentFieldIndexRef.current = 0;
    }

    const currentField = fields[currentFieldIndexRef.current] as HTMLElement;

    if (currentField) {
      currentField.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      currentFieldIndexRef.current += 1;
    }
  };

  return (
    <Button onClick={handleClick}>
      <T
        _str="Next"
        _comment="Button text to show the next missing required field"
      />
    </Button>
  );
};

export { UnassignedFieldsToastButton };
